(function () {
  const root = document.querySelector("[data-mvc]");
  if (!root) return;
  const itemsEl = root.querySelector("[data-mvc-items]");
  const titleEl = document.getElementById("mvc-title");
  const totalEl = root.querySelector("[data-mvc-total]");
  const money = (cents, currency) => {
    const cur = currency || "CZK";
    const n = (cents / 100).toFixed(2).replace(".", ",");
    if (cur === "CZK") {
      const p = n.split(",");
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return p.join(",") + " Kč";
    }
    if (cur === "EUR") return n + " €";
    if (cur === "USD") return "$" + (cents / 100).toFixed(2);
    return n + " " + cur;
  };
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  function releasePage() {
    document.querySelectorAll(".page-wrapper--drawer-open").forEach((el) => el.classList.remove("page-wrapper--drawer-open"));
    const dialog = document.querySelector("#cart-drawer dialog");
    if (dialog && dialog.open && dialog.close) dialog.close();
    document.body.style.overflow = "";
  }
  function open() { releasePage(); root.hidden = false; document.body.style.overflow = "hidden"; }
  function close() { root.hidden = true; releasePage(); }
  function render(cart) {
    const n = cart.item_count || 0;
    titleEl.textContent = n ? "Košík · " + n : "Košík";
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="mvc__empty">Košík je prázdný.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map((item) => {
        const variant = item.variant_title && item.variant_title !== "Default Title" ? "<p class='mvc__meta'>" + esc(item.variant_title) + "</p>" : "";
        return "<article class='mvc__line'><img src='" + (item.image || "") + "' alt=''><div><h3><a href='" + esc(item.url) + "'>" + esc(item.product_title) + "</a></h3>" + variant +
          "<div class='mvc__qty'><button type='button' data-mvc-qty='" + item.key + "' data-q='" + (item.quantity - 1) + "'>−</button><span>" + item.quantity + "</span><button type='button' data-mvc-qty='" + item.key + "' data-q='" + (item.quantity + 1) + "'>+</button></div></div>" +
          "<div class='mvc__price'><button type='button' class='mvc__trash' data-mvc-qty='" + item.key + "' data-q='0' aria-label='Odebrat'>×</button><b>" + money(item.final_line_price, cart.currency) + "</b></div></article>";
      }).join("");
    }
    totalEl.textContent = money(cart.total_price, cart.currency);
  }
  async function load(show) {
    const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    const cart = await fetch(rootPath + "cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
    render(cart);
    if (show) open();
  }
  async function change(key, qty) {
    const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    await fetch(rootPath + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) });
    await load(true);
  }
  root.querySelectorAll("[data-mvc-close]").forEach((el) => el.addEventListener("click", close));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !root.hidden) close(); });
  itemsEl.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-mvc-qty]");
    if (!btn) return;
    change(btn.getAttribute("data-mvc-qty"), Number(btn.getAttribute("data-q")));
  });
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-testid='cart-drawer-trigger'], [aria-controls='cart-drawer'], a[href$='/cart'], cart-icon, .header-actions__cart-icon");
    if (!trigger) return;
    const a = trigger.closest("a");
    if (a) {
      let path = "";
      try { path = new URL(a.href, location.origin).pathname; } catch (err) { path = ""; }
      if (path && !/\/cart\/?$/.test(path) && !trigger.matches("[aria-controls='cart-drawer'], cart-icon, .header-actions__cart-icon")) return;
    }
    e.preventDefault();
    e.stopPropagation();
    load(true);
  }, true);
  document.addEventListener("variant:add", () => load(true));
  document.addEventListener("miteva:cart", () => load(true));
  window.MitevaCart = { open: () => load(true), close };
})();
